import React, { useEffect, useRef } from 'react';
import T from 'prop-types';
import { useDispatch } from 'react-redux';

import MarketOverview from '../components/MarketOverview';
import TrendsSummary from '../components/TrendsSummary';
import TimeSpentPenetration from '../components/TsPenetration';
import MarketBehavior from '../components/MarketBehavior';
import AppImpact from '../components/AppImpact';
import FullAccessBanner from '../components/FullAccessBanner';
import SectorsStats from '../components/SectorsStats';
import AppTrends from '../components/AppTrends';
import AiStickyHeader from '../components/AiStickyHeader';
import AiTabNavigation from '../components/AiTabNavigation';
import TabExportButton from '../components/TabExportButton';
import AiDashboardStaticView from '../components/AiDashboardStaticView';
import PreviewTopBanner from '../components/PreviewTopBanner';
import PreviewBottomSection from '../components/PreviewBottomSection';
import Container from '../../../components/Container';
import { fetchAiDashboardData } from '../actions';
import { scrollToSection } from '../hooks/useAiDashboardNav';

const AiDashboardContainer = ({
  isPublic = false,
  campaignEnded = false,
  showAiBanner = false,
}) => {
  const dispatch = useDispatch();

  const stickySentinelRef = useRef(null);

  useEffect(() => {
    dispatch(fetchAiDashboardData({ campaignEnded }));
  }, [dispatch, campaignEnded]);

  return (
    <>
      {(isPublic || showAiBanner) && <PreviewTopBanner campaignEnded={campaignEnded} />}
      <div className="ai-dashboard-tab">
        <AiStickyHeader stickySentinelRef={stickySentinelRef} />
        <Container maxWidth={1128}>
          <header className="ai-dashboard-tab-content-header">
            <AiTabNavigation onScrollToSection={scrollToSection} />
            <TabExportButton isPublic={isPublic || campaignEnded} />
          </header>
          <div ref={stickySentinelRef} className="sticky-sentinel" />
          <div className="ai-dashboard-tab-content">
            {campaignEnded ? (
              <AiDashboardStaticView />
            ) : (
              <>
                <div id="market-overview">
                  <MarketOverview allowQV={!isPublic} />
                </div>
                <div className="section-separator" />
                {isPublic && <FullAccessBanner />}
                <div id="behavioral-trends">
                  <TrendsSummary allowQV={!isPublic} />
                </div>
                <div id="share-of-screen-time">
                  <TimeSpentPenetration />
                </div>
                <div id="market-behavior">
                  <MarketBehavior />
                </div>
                <div id="screen-time-by-sector">
                  <SectorsStats />
                </div>
                <div id="app-trends">
                  <AppTrends />
                </div>
                <div id="ai-app-impact">
                  <AppImpact isPublic={isPublic} />
                </div>
              </>
            )}
          </div>
        </Container>
      </div>
      {isPublic && <PreviewBottomSection />}
    </>
  );
};

AiDashboardContainer.propTypes = {
  isPublic: T.bool,
  campaignEnded: T.bool,
  showAiBanner: T.bool,
};

export default AiDashboardContainer;
